<template>
  <vxe-grid
    auto-resize
    highlight-hover-row
    :toolbar-config="tableToolbar"
    :data="tableData"
    :columns="tableColumns"
    :loading="loading"
    :height="tableHeight"
    size="small"
    resizable
    border
    :seq-config="{
      startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
    }"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:pager>
      <slot name="pager"></slot>
    </template>
    <template v-slot:uploadStatus="{ row }">
      <el-tag
        size="mini"
        :type="
          row.uploadStatus === 'N'
            ? 'info'
            : row.uploadStatus === 'Y'
            ? 'success'
            : row.uploadStatus === 'F'
            ? 'danger'
            : 'warning'
        "
      >
        {{ row.v_uploadStatus }}
      </el-tag>
    </template>
    <template v-slot:lineStatus="{ row }">
      <el-tag
        size="mini"
        :type="
          row.lineStatus === 'N'
            ? 'info'
            : row.lineStatus === 'Y'
            ? 'success'
            : 'danger'
        "
      >
        {{ row.v_lineStatus }}
      </el-tag>
    </template>
    <template v-slot:opt="{ row }">
      <div>
        <el-tooltip
          class="item"
          effect="dark"
          :content="'查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="
              $emit('openEditFormDialog', {
                type: 'detail',
                code: row.receiveLineCode,
              })
            "
          ></i>
        </el-tooltip>
      </div>
    </template>
    <template v-slot:empty="{}">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">暂无数据！</p>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
    }
  },
  methods: {},
}
</script>
